import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../../../utils/callApi'
import { API_ROUTES } from '../../../../utils/apiRoutes'
import { ActionTypes, IGetFavoritesActivityChild, TFavoritesActivity } from './types'

function* getFavoritesActivityWorker(action: ReturnType<typeof Actions.GetFavoritesActivity.request>) {
  const { callBack, idTender, offset, limit, search, sortBy, sort } =
    action.payload as Actions.TypeGetFavoritesActivityR
  let success = true
  let data = null

  let query = `?Offset=${offset || 0}&Limit=${limit || 20}`
  query += search ? `&Search=${search}` : ''
  query += sortBy ? `&SortBy=${sortBy}` : ''
  query += sort ? `&Sort=${sort}` : ''
  query += `&Statistic=true`

  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminTenders}/${idTender}/items${query}`,
    })) as TFavoritesActivity[]
    if (offset !== 0) {
      yield put(Actions.GetFavoritesActivity.success(data))
    } else {
      yield put(Actions.GetFavoritesActivityWith0Offset.success(data))
    }
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetFavoritesActivity.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* getFavoritesActivityChildWorker(action: ReturnType<typeof Actions.GetFavoritesActivityChild.request>) {
  const { callBack, idTender, idItem } = action.payload as Actions.TypeGetFavoritesActivityChildR
  let success = true
  let data = null

  let query = `?Offset=${0}&Limit=${100}`
  query += `&WishlistItemId=${idItem}`

  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminGetUsers}${query}`,
    })) as IGetFavoritesActivityChild

    const { users } = data

    yield put(Actions.GetFavoritesActivityChild.success({ data: users, idItem: +`${idTender}${idItem}` }))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetFavoritesActivityChild.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.GET_FAVORITES_ACTIVITY_R, getFavoritesActivityWorker)
  yield takeEvery(ActionTypes.GET_FAVORITES_ACTIVITY_CHILD_R, getFavoritesActivityChildWorker)
}

export default function* favoritesActivitySaga() {
  yield all([fork(watchRequest)])
}
